import { createSelector } from '@reduxjs/toolkit';

import { RootState } from './index';

// Game selectors
export const selectGameState = (state: RootState) => state.game;
export const selectGameItems = (state: RootState) => state.game.items;
export const selectGameLoading = (state: RootState) => state.game.loading;
export const selectClaimedPrizes = (state: RootState) => state.game.claimedPrizes;
export const selectWalletAmount = (state: RootState) => state.game.walletAmount;
export const selectClaimedPrizeIds = (state: RootState) => state.game.claimedPrizeIds;
export const selectAppState = (state: RootState) => state.game.appState;
export const selectSelectedProduct = (state: RootState) => state.game.selectedProduct;
export const selectSelectedProductVariants = (state: RootState) => state.game.selectedProductVariants;
export const selectHasShownSelectProductNotification = (state: RootState) =>
  state.game.hasShownSelectProductNotification;
export const selectSelectedVariantId = (state: RootState) => state.game.selectedVariantId;

// Product selectors
export const selectCachedProducts = (state: RootState) => state.products.cachedProducts;
export const selectCachedProduct = (productId: string) =>
  createSelector([selectCachedProducts], (cachedProducts) => {
    return null; // Disable product caching
    const cachedProduct = cachedProducts[productId];
    if (!cachedProduct) return null;

    // Optional: Add cache invalidation logic here
    // const CACHE_TTL = 5 * 60 * 1000; // 5 minutes
    // if (Date.now() - cachedProduct.timestamp > CACHE_TTL) {
    //   return null;
    // }

    return cachedProduct.data;
  });

// Confirmation selectors
export const selectConfirmationState = (state: RootState) => state.confirmation;
export const selectIsProductConfirmationMode = (state: RootState) => state.confirmation.isProductConfirmationMode;
export const selectIsProductConfirmed = (state: RootState) => state.confirmation.isProductConfirmed;

// Notification selectors
export const selectNotificationState = (state: RootState) => state.notification;
export const selectNotificationMessage = (state: RootState) => state.notification.message;
export const selectNotificationVisible = (state: RootState) => state.notification.isVisible;
export const selectNotificationYPosition = (state: RootState) => state.notification.yPosition;

// Settings selectors
export const selectSettingsState = (state: RootState) => state.settings;
export const selectSettings = (state: RootState) => state.settings.data;
export const selectSettingsLoading = (state: RootState) => state.settings.loading;
export const selectSettingsError = (state: RootState) => state.settings.error;
export const selectSettingsLastFetched = (state: RootState) => state.settings.lastFetched;
